import React from 'react';

function Equipments() {
  return (
    <div id="equipments">
      <p>[Equipments]</p>
    </div>
  );
}

Equipments.propTypes = {};

export default Equipments;
